import { AssessmentCasePreview, CasePreview, ControlCasePreview } from 'src/app/case/model/case.model';
import { Component, Input } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectHasPolicy } from 'src/app/authentication/store/user.selector';
import { fetchBuildingCase } from 'src/app/building/store/building-case.action';
import { mergeMap, tap } from 'rxjs/operators';
import { selectCasePreviews } from 'src/app/building/store/building.selector';
import { combineLatest, Observable, of } from 'rxjs';
import { LinkButtonComponent } from '../../buttons/link-button.component';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'sibat-case-preview',
  templateUrl: './case-preview.component.html',
  styleUrls: ['./case-preview.component.scss'],
  imports: [LinkButtonComponent, RouterLink, AsyncPipe],
})
export class CasePreviewComponent {
  @Input() casePreviews: (CasePreview | ControlCasePreview | AssessmentCasePreview)[];

  casePreviews$ = combineLatest([
    this.store.select(selectHasPolicy('case.previewDetails.get')),
    (this.route.parent ?? this.route).params,
  ]).pipe(
    tap(([hasPolicy, { buildingId }]) => {
      if (hasPolicy && this.casePreviews === undefined) {
        this.store.dispatch(fetchBuildingCase({ buildingId }));
      }
    }),
    mergeMap(() => {
      if (this.casePreviews !== undefined) {
        return of(this.casePreviews);
      }
      return this.store.select(selectCasePreviews);
    })
  ) as Observable<(CasePreview | ControlCasePreview | AssessmentCasePreview)[]>;

  constructor(private store: Store, private route: ActivatedRoute) {}

  public isCasePreview(casePreview: CasePreview | ControlCasePreview | AssessmentCasePreview): casePreview is CasePreview {
    return 'friacFolderNumber' in casePreview && !!casePreview.friacFolderNumber;
  }

  public isControlCasePreview(casePreview: CasePreview | ControlCasePreview | AssessmentCasePreview): casePreview is ControlCasePreview {
    return casePreview.type === 'CONTROL';
  }

  public isAssessmentCasePreview(
    casePreview: CasePreview | ControlCasePreview | AssessmentCasePreview
  ): casePreview is AssessmentCasePreview {
    return casePreview.type === 'ASSESSMENT';
  }

  public formatDateLabelTimestamp(timestamp: string): string {
    const date = new Date(parseInt(timestamp, 10) * 1000);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  }
}
